import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

const RESTOCKING_RULES = 'merchant-restocking-rules';

const useRestockingRulesFeatureFlag = (country: Country) => {
  const { isEmployee, user } = useUser();
  const { data, isLoading } = useFeatureFlags([RESTOCKING_RULES], {
    country,
    user_id: user?.id ?? '',
    is_employee: isEmployee,
  });

  return { enabled: data?.[RESTOCKING_RULES] === 'on', isLoading };
};

export default useRestockingRulesFeatureFlag;
